const APP_NAMES = {
  iplena: 'iPlena',
  mevotec: 'Mevotec',
  imed: 'iMedCoach',
  default: 'iPlena',
};

const getAppName = (theme: string) => {
  return APP_NAMES[theme] || APP_NAMES.default;
};

export const CONFIG = {
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  API_SERVER: process.env.REACT_APP_API_SERVER,
  TOKEN_KEY: 'youposture-token',
  TRAINING_KEY: 'youposture-train-logs',
  CHALLENGE_HISTORY_KEY: 'youposture-challenge-histories',
  CONFIRMED_TRAIN_KEY: 'youposture-confirmed-train',
  FIREBASE: {
    API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  THEME: process.env.REACT_APP_THEME,
  LOGO: process.env.REACT_APP_LOGO,
  APP_NAME: getAppName(process.env.REACT_APP_THEME),
};
